import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

const ItoMiniPmNotBooked = (props) => {
   const theme = useTheme();
   return (
      <SvgIcon {...props} color="primary" viewBox="0 0 26 29">
         <g
            id="ITO-Design-System"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
         >
            <g
               id="ito-mini-pm-notBooked"
               fill={theme.palette.primary.main}
               fillRule="nonzero"
            >
               <path
                  d="M26,0 L26,24.862325 C26,27.1474998 24.209139,29 22,29 L4,29 C1.790861,29 0,27.1474998 0,24.862325 L0,17.1041844 L26,0 Z M25,1.5093518 L1.0024487,17.6635581 L1,24.862325 C1,26.5149961 2.24891996,27.8659263 3.82372721,27.9603133 L4,27.9655813 L22,27.9655813 C23.6568542,27.9655813 25,26.5762061 25,24.862325 L25,1.5093518 Z M21.7272727,11.4 L23,12.758209 L12.0909091,24.4 L7,18.9671642 L8.27272727,17.6089552 L12.0909091,21.6835821 L21.7272727,11.4 Z"
                  id="Path-2"
               ></path>
            </g>
         </g>
      </SvgIcon>
   );
};

export default ItoMiniPmNotBooked;
